<template>
    <div class="designerpage">

        <konic-doors-designer-question-door-range v-if="range_panel_required"
                                                     :fabricator="fabricator"
                                                     v-model:target="door.attr.door_range"
                                                     :ranges="ranges"
                                                     :defaults="defaults()"
                                                     title="Choose a Door Range"
                                                     :reference_on="reference_on"></konic-doors-designer-question-door-range>

        <div>
            <wb-designer-question-select-door :fabricator="fabricator"
                                              :secured-by-design="door.attr.secured_by_design"
                                              :door-range="door.attr.door_range"
                                              v-model:target="door.attr.slab"></wb-designer-question-select-door>

            <designer-question-georgian-bars :fabricator="fabricator"
                                             :slab="door.attr.slab"
                                             v-model:target="door.attr.georgian_bars"
            ></designer-question-georgian-bars>

            <designer-question-moulding :fabricator="fabricator"
                                        v-model:target="door.attr.moulding"
                                        :slab="door.attr.slab"
            ></designer-question-moulding>

            <designer-question-steel-inserts :fabricator="fabricator"
                                             :slab="door.attr.slab"
                                             v-model:target="door.attr.steel_inserts"
            ></designer-question-steel-inserts>

            <designer-question-frame-material :slab="door.attr.slab"
                                                 :fabricator="fabricator"
                                                 v-model:target="door.attr.frame_material"></designer-question-frame-material>
        </div>

        <div class="designeroption">
            <designer-question-hinge-side :fabricator="fabricator"
                                          v-model:target="door.attr.hinge_side"
                                          v-show="!is_french"
            ></designer-question-hinge-side>

            <designer-question-opening-direction v-show="technical_should_show" :fabricator="fabricator"
                                                 v-model:target="door.attr.opening_direction"></designer-question-opening-direction>
        </div>

        <div>
            <wb-designer-question-french-master :fabricator="fabricator" v-model:target="door.attr.french_master"
                                                title="Select Your Master Door"
                                                v-if="is_french"></wb-designer-question-french-master>
        </div>

        <konic-doors-designer-question-select-frame-style v-show="!is_firedoorrange && !is_french"
                                                             :fabricator="fabricator"
                                                             :is-firedoor="is_firedoorrange"
                                                             :is_french="is_french"
                                                             v-model:target="door.attr.frame_style"
                                                             :frame-material="door.attr.frame_material"></konic-doors-designer-question-select-frame-style>

        <konic-doors-french-designer-question-select-frame-style :fabricator="fabricator"
                                                        :frame-material="door.attr.frame_material"
                                                        :is-firedoor="is_firedoorrange"
                                                        v-model:target="door.attr.frame_style"
                                                        v-if="is_french"></konic-doors-french-designer-question-select-frame-style>



      <template v-if="door.attr.frame_style.frame_id !== undefined">
        <div class="row">
          <div class="col-sm">
            <div class="designeroption" data-designer-component-id="external_colour">

              <h3>Choose Your External Door Colour</h3>

              <wb-designer-question-door-colour-external :fabricator="fabricator" :slab="door.attr.slab"
                                                         :door-range="door.attr.door_range"
                                                         v-model:target="door.attr.external_colour"></wb-designer-question-door-colour-external>

              <div class="stylesoption">
                <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.external_colour"
                                              title="External Door Colour"
                                              v-model:target="door.attr.external_colour_ral"></designer-question-ral-colour>
              </div>

            </div>
          </div>
          <div class="col-sm">
            <div class="designeroption" data-designer-component-id="door_colour_internal">

              <h3>Choose Your Internal Door Colour</h3>


              <futureproducts-designer-question-door-colour-internal :fabricator="fabricator"
                                                                     :slab="door.attr.slab"
                                                                     :external-colour="door.attr.external_colour"
                                                                     :door-range="door.attr.door_range"
                                                                     v-model:target="door.attr.door_colour_internal"></futureproducts-designer-question-door-colour-internal>

              <div class="stylesoption">
                <designer-question-ral-colour :fabricator="fabricator"
                                              :colour-id="door.attr.door_colour_internal"
                                              title="Internal Door Colour"
                                              v-model:target="door.attr.door_colour_internal_ral"></designer-question-ral-colour>
              </div>

            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm">
            <div class="designeroption" data-designer-component-id="frame_colour_external">

              <h3>Choose Your External Frame Colour</h3>

              <wb-designer-question-frame-colour-external :fabricator="fabricator"
                                                          :frame-material="door.attr.frame_material"
                                                          :slab="door.attr.slab"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          v-model:target="door.attr.frame_colour_external"></wb-designer-question-frame-colour-external>

              <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_external"
                                            title="External Frame Colour"
                                            v-model:target="door.attr.frame_colour_external_ral"></designer-question-ral-colour>
            </div>
          </div>
          <div class="col-sm">
            <div class="designeroption" data-designer-component-id="frame_colour_internal">

              <h3>Choose Your Internal Frame Colour</h3>

              <wb-designer-question-frame-colour-internal :fabricator="fabricator"
                                                          :frame-colour-external="door.attr.frame_colour_external"
                                                          :slab="door.attr.slab"
                                                          :profile="door.attr.profile"
                                                          :door-range="door.attr.door_range"
                                                          v-model:target="door.attr.frame_colour_internal"
                                                          :frame-material="door.attr.frame_material"></wb-designer-question-frame-colour-internal>

              <designer-question-ral-colour :fabricator="fabricator" :colour-id="door.attr.frame_colour_internal"
                                            title="Internal Frame Colour"
                                            v-model:target="door.attr.frame_colour_internal_ral"></designer-question-ral-colour>
            </div>
          </div>
        </div>

        <div>

          <div class="designeroption">
            <designer-question-door-glass-laminated :fabricator="fabricator"
                                                    title="Laminated Glass:"
                                                    :slab="door.attr.slab"
                                                    :frame-style="door.attr.frame_style"
                                                    :side-panels="door.attr.side_panels"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :is-firedoor="is_firedoorrange"
                                                    v-model:target="door.attr.laminated_glass"></designer-question-door-glass-laminated>
          </div>

        </div>

        <div>
          <wb-designer-question-glass-design :fabricator="fabricator"
                                             v-model:target="door.attr.glass_design"
                                             :laminated-glass="door.attr.laminated_glass"
                                             :door-range="door.attr.door_range"
                                             :slab="door.attr.slab"></wb-designer-question-glass-design>

          <designer-question-glass-text :fabricator="fabricator"
                                        v-model:target="door.attr.glass_text"
                                        :glass-design="door.attr.glass_design"
                                        max_char="30"
                                        title="Bespoke Detail"
          ></designer-question-glass-text>
        </div>

        <wb-designer-question-glass-backing-design :fabricator="fabricator"
                                                   v-model:target="door.attr.glass_backing_design"
                                                   :slab="door.attr.slab"
                                                   :glass-design="door.attr.glass_design"></wb-designer-question-glass-backing-design>

        <designer-question-select-frame-sidepanels :fabricator="fabricator"
                                                   v-model:target="door.attr.side_panels"
                                                   :door-range="door.attr.door_range"
                                                   :frame-style="door.attr.frame_style"
                                                   :frame-profile="door.attr.profile"
                                                   :frame-material="door.attr.frame_material"
                                                   :laminated-glass="door.attr.laminated_glass"
                                                   :frame-colour-internal="door.attr.frame_colour_internal"
                                                   :frame-colour-external="door.attr.frame_colour_external"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :slab="door.attr.slab"
                                                   :measurements.sync="door.attr.measurements"
                                                   :cill="door.attr.cill"
                                                   :threshold="door.attr.threshold"></designer-question-select-frame-sidepanels>

        <konic-doors-designer-question-collection-bottom-panel :fabricator="fabricator"
                                                               :title="'Select your bottom panel style'"
                                                               :question="'side_panel'"
                                                               v-model:target="door.attr.side_panels.lower_sidepanel_type"
                                                               :side-variant-left="door.attr.side_panels.left"
                                                               :side-variant-right="door.attr.side_panels.right"
        ></konic-doors-designer-question-collection-bottom-panel>


        <div>
          <wb-designer-question-hardware-colour :fabricator="fabricator"
                                                v-model:target="door.attr.hardware_colour"
                                                :sbd="door.attr.secured_by_design"
                                                :slab="door.attr.slab"
                                                :door-range="door.attr.door_range"
                                                :profile="door.attr.profile"
                                                :opening-direction="door.attr.opening_direction"></wb-designer-question-hardware-colour>
        </div>
        <div>
          <wb-designer-question-hardware-handle :fabricator="fabricator"
                                                v-model:target="door.attr.hardware_handle"
                                                :slab="door.attr.slab"
                                                :secured-by-design="door.attr.secured_by_design"
                                                :opening-direction="door.attr.opening_direction"
                                                :hardware-colour="door.attr.hardware_colour"
                                                :door-range="door.attr.door_range"
                                                :profile="door.attr.profile"></wb-designer-question-hardware-handle>

          <wb-designer-question-hardware-handle-internal :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_handle_internal"
                                                         :slab="door.attr.slab"
                                                         :secured-by-design="door.attr.secured_by_design"
                                                         :opening-direction="door.attr.opening_direction"
                                                         :hardware-colour="door.attr.hardware_colour"
                                                         :door-range="door.attr.door_range"
                                                         :profile="door.attr.profile"
                                                         :handle-external="door.attr.hardware_handle"></wb-designer-question-hardware-handle-internal>

          <konic-doors-designer-question-hardware-handle-slave :door-range="door.attr.door_range" :fabricator="fabricator"
                                                               :hardware-colour="door.attr.hardware_colour"
                                                               :hardware-handle="door.attr.hardware_handle"
                                                               :hardware-suite="door.attr.suite"
                                                               :opening-direction="door.attr.opening_direction"
                                                               :profile="door.attr.profile"
                                                               :secured-by-design="door.attr.secured_by_design"
                                                               :slab="door.attr.slab"
                                                               v-model:target="door.attr.hardware_handle_slave"
                                                               title="Select Your Slave Handle"
                                                               v-if="is_french"></konic-doors-designer-question-hardware-handle-slave>

          <designer-question-hardware-handle-split-spindle v-show="technical_should_show" :fabricator="fabricator"
                                                           v-model:target="door.attr.hardware_handle_split_spindle"
                                                           :hardware-handle="door.attr.hardware_handle"
                                                           :slab="door.attr.slab"></designer-question-hardware-handle-split-spindle>

          <div v-show="false">
            <designer-question-hardware-decorative-handle :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_decorative_handle"
                                                          :slab="door.attr.slab"
                                                          :hardware-colour="door.attr.hardware_colour"
                                                          :door-range="door.attr.door_range"
                                                          :title="'Select your decorative knob'"></designer-question-hardware-decorative-handle>

            <designer-question-hardware-decorative-handle-position :fabricator="fabricator"
                                                                   v-model:target="door.attr.hardware_decorative_handle_pos"
                                                                   :slab="door.attr.slab"
                                                                   :frame-material="door.attr.frame_material"
                                                                   :hardware-decorative-handle="door.attr.hardware_decorative_handle"></designer-question-hardware-decorative-handle-position>
          </div>
        </div>
        <div>
          <wb-designer-question-hardware-escutcheon :fabricator="fabricator"
                                                    v-model:target="door.attr.hardware_escutcheon"
                                                    :slab="door.attr.slab"
                                                    :secured-by-design="door.attr.secured_by_design"
                                                    :hardware-colour="door.attr.hardware_colour"
                                                    :hardware-handle="door.attr.hardware_handle"
                                                    :door-range="door.attr.door_range"
                                                    :profile="door.attr.profile"></wb-designer-question-hardware-escutcheon>

          <designer-question-hardware-escutcheon-position :fabricator="fabricator"
                                                          v-model:target="door.attr.hardware_escutcheon_pos"
                                                          :slab="door.attr.slab"
                                                          :frame-material="door.attr.frame_material"
                                                          :hardware-escutcheon="door.attr.hardware_escutcheon"></designer-question-hardware-escutcheon-position>
        </div>
        <div v-show="technical_should_show">
          <!--            <designer-question-hardware-lock :fabricator="fabricator"-->
          <!--                                             v-model:target="door.attr.hardware_lock"-->
          <!--                                             :secured-by-design="door.attr.secured_by_design"-->
          <!--                                             :hinge-side="door.attr.hinge_side"-->
          <!--                                             :slab="door.attr.slab"-->
          <!--                                             :frame-material="door.attr.frame_material"-->
          <!--                                             :hardware-handle="door.attr.hardware_handle"-->
          <!--                                             :opening_direction="door.attr.opening_direction"-->
          <!--                                             :hardware-escutcheon="door.attr.hardware_escutcheon"-->
          <!--                                             :door-range="door.attr.door_range"-->
          <!--                                             :maintitle="'Choose Your Lock'"-->
          <!--            ></designer-question-hardware-lock>-->

          <designer-question-hardware-cylinder v-show="technical_should_show" :fabricator="fabricator"
                                               title="Choose Your Cylinder"
                                               :slab="door.attr.slab"
                                               v-model:target="door.attr.hardware_cylinder"
                                               :secured-by-design="door.attr.secured_by_design"
                                               :hardware-lock="door.attr.hardware_lock"
                                               :hardware-colour="door.attr.hardware_colour"
                                               :opening_direction="door.attr.opening_direction"
                                               :hardware-handle="door.attr.hardware_handle"
                                               :door-range="door.attr.door_range"></designer-question-hardware-cylinder>
        </div>

        <div>
          <wb-designer-question-hardware-letterbox :fabricator="fabricator"
                                                   v-model:target="door.attr.hardware_letterbox"
                                                   :secured-by-design="door.attr.secured_by_design"
                                                   :slab="door.attr.slab"
                                                   :side-panels="door.attr.side_panels"
                                                   :frame-id="door.attr.frame_style.frame_id"
                                                   :hardware-handle="door.attr.hardware_handle"
                                                   :hardware-colour="door.attr.hardware_colour"
                                                   :door-range="door.attr.door_range"></wb-designer-question-hardware-letterbox>

          <designer-question-hardware-letterbox-cowl :fabricator="fabricator"
                                                     v-model:target="door.attr.hardware_letterbox_cowl"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     :hardware-letterplate="door.attr.hardware_letterbox"
                                                     :hardware-colour="door.attr.hardware_colour"></designer-question-hardware-letterbox-cowl>

          <designer-question-hardware-letterbox-position :fabricator="fabricator"
                                                         v-model:target="door.attr.hardware_letterbox_pos"
                                                         :slab="door.attr.slab"
                                                         :side-panels="door.attr.side_panels"
                                                         :frame-id="door.attr.frame_style.frame_id"
                                                         :frame-material="door.attr.frame_material"
                                                         :hardware-letterbox="door.attr.hardware_letterbox"
                                                         :door-range="door.attr.door_range"></designer-question-hardware-letterbox-position>
        </div>
        <div v-show="!is_french">
          <wb-designer-question-hardware-knocker :fabricator="fabricator"
                                                 v-model:target="door.attr.hardware_knocker"
                                                 :slab="door.attr.slab"
                                                 :hardware-handle="door.attr.hardware_handle"
                                                 :hardware-spyhole="door.attr.hardware_spy_hole"
                                                 :hardware-colour="door.attr.hardware_colour"
                                                 :door-range="door.attr.door_range"></wb-designer-question-hardware-knocker>

          <designer-question-hardware-knocker-position :fabricator="fabricator"
                                                       v-model:target="door.attr.hardware_knocker_pos"
                                                       :slab="door.attr.slab"
                                                       :frame-material="door.attr.frame_material"
                                                       :hardware-knocker="door.attr.hardware_knocker"></designer-question-hardware-knocker-position>
        </div>
        <!--        <div>-->
        <!--            <wb-designer-question-hardware-spy-hole :fabricator="fabricator"-->
        <!--                                                    v-model:target="door.attr.hardware_spy_hole"-->
        <!--                                                    :slab="door.attr.slab"-->
        <!--                                                    :secured-by-design="door.attr.secured_by_design"-->
        <!--                                                    :glass-design="door.attr.glass_design"-->
        <!--                                                    :hardware-handle="door.attr.hardware_handle"-->
        <!--                                                    :hardware-knocker="door.attr.hardware_knocker"-->
        <!--                                                    :hardware-colour="door.attr.hardware_colour"-->
        <!--                                                    :door-range="door.attr.door_range"></wb-designer-question-hardware-spy-hole>-->

        <!--            <designer-question-hardware-spy-hole-position :fabricator="fabricator"-->
        <!--                                                          v-model:target="door.attr.hardware_spy_hole_pos"-->
        <!--                                                          :slab="door.attr.slab"-->
        <!--                                                          :frame-material="door.attr.frame_material"-->
        <!--                                                          :hardware-spy-hole="door.attr.hardware_spy_hole"></designer-question-hardware-spy-hole-position>-->
        <!--        </div>-->
        <!--        <div class="designeroption" v-show="technical_should_show">-->
        <!--            <designer-question-hardware-numerals :fabricator="fabricator"-->
        <!--                                                 v-model:target="door.attr.numerals"-->
        <!--                                                 :slab="door.attr.slab"-->
        <!--                                                 :hardware-handle="door.attr.hardware_handle"-->
        <!--                                                 :hardware-colour="door.attr.hardware_colour"-->
        <!--                                                 title="Numerals"></designer-question-hardware-numerals>-->
        <!--        </div>-->

        <!--        <wb-designer-question-hardware-hinge :fabricator="fabricator"-->
        <!--                                             v-model:target="door.attr.hardware_hinge"-->
        <!--                                             :slab="door.attr.slab"-->
        <!--                                             :opening_direction="door.attr.opening_direction"-->
        <!--                                             :secured-by-design="door.attr.secured_by_design"-->
        <!--                                             :hardware-colour="door.attr.hardware_colour"-->
        <!--                                             :hinge-side="door.attr.hinge_side"-->
        <!--                                             :frame-material="door.attr.frame_material"-->
        <!--                                             :door-range="door.attr.door_range"-->
        <!--        ></wb-designer-question-hardware-hinge>-->

        <div v-show="false">
          <designer-question-hardware-security-chain :fabricator="fabricator"
                                                     :secured-by-design="door.attr.secured_by_design"
                                                     v-model:target="door.attr.hardware_security_chain"
                                                     :hardware-colour="door.attr.hardware_colour"
                                                     :door-range="door.attr.door_range"></designer-question-hardware-security-chain>
        </div>

        <div v-show="technical_should_show">
          <wb-designer-question-technical-profile :fabricator="fabricator"
                                                  :frame-colour-internal="door.attr.frame_colour_internal"
                                                  :frame-colour-external="door.attr.frame_colour_external"
                                                  :frame-material="door.attr.frame_material"
                                                  :secured-by-design="door.attr.secured_by_design"
                                                  :hardware-handle="door.attr.hardware_handle"
                                                  :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                  :door-range="door.attr.door_range"
                                                  :opening-direction="door.attr.opening_direction"
                                                  v-model:target="door.attr.profile"></wb-designer-question-technical-profile>
        </div>

        <div v-show="technical_should_show">
          <konic-doors-designer-question-technical-threshold :fabricator="fabricator"
                                                             title="Choose Your Threshold"
                                                             v-model:target="door.attr.threshold"
                                                             :opening-direction="door.attr.opening_direction"
                                                             :frame-profile="door.attr.profile"
                                                             :door-range="door.attr.door_range"></konic-doors-designer-question-technical-threshold>


          <designer-question-sidepanel-threshold v-if="passed_filter_left && !is_firedoorrange"
                                                 :fabricator="fabricator"
                                                 title="Choose Your Left Side Threshold"
                                                 v-model:target="door.attr.side_panels.left_threshold_id"
                                                 :frame-profile="door.attr.profile"
                                                 :threshold="door.attr.threshold"
                                                 :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>


          <designer-question-sidepanel-threshold v-if="passed_filter_right && !is_firedoorrange"
                                                 :fabricator="fabricator"
                                                 title="Choose Your Right Side Threshold"
                                                 v-model:target="door.attr.side_panels.right_threshold_id"
                                                 :frame-profile="door.attr.profile"
                                                 :threshold="door.attr.threshold"
                                                 :door-range="door.attr.door_range"></designer-question-sidepanel-threshold>

        </div>

        <div class="designeroption" v-show="false">
          <h3>Select Any Required Risers</h3>
          <designer-question-technical-cill :fabricator="fabricator"
                                            v-model:target="door.attr.cill"
                                            :frame-colour-internal="door.attr.frame_colour_internal"
                                            :frame-colour-external="door.attr.frame_colour_external"
                                            :opening-direction="door.attr.opening_direction"
                                            :frame-profile="door.attr.profile"
                                            :threshold="door.attr.threshold"
                                            :component_id="'cill'"
                                            :show_cill_horn_text="false"
                                            extra_text="Your Riser will be 100mm wider than the overall width. Please enter exact thickness in notes section."
          ></designer-question-technical-cill>

          <designer-question-technical-cill v-if="left_flag_sill" :fabricator="fabricator"
                                            v-model:target="door.attr.side_panels.left_flag_sill_id"
                                            :frame-colour-internal="door.attr.frame_colour_internal"
                                            :frame-colour-external="door.attr.frame_colour_external"
                                            :frame-profile="door.attr.profile"
                                            :title="'Left Sidepanel Flag'"
                                            :component_id="'left_flag_cill'"
          ></designer-question-technical-cill>

          <designer-question-technical-cill v-if="right_flag_sill" :fabricator="fabricator"
                                            v-model:target="door.attr.side_panels.right_flag_sill_id"
                                            :frame-colour-internal="door.attr.frame_colour_internal"
                                            :frame-colour-external="door.attr.frame_colour_external"
                                            :frame-profile="door.attr.profile"
                                            :title="'Right Sidepanel Flag'"
                                            :component_id="'right_flag_cill'"
          ></designer-question-technical-cill>
        </div>

        <div>
          <div v-show="technical_should_show">

            <!--                <wb-designer-question-door-drip-colour :fabricator="fabricator"-->
            <!--                                                       title="Choose A Door Drip colour"-->
            <!--                                                       :external-colour="door.attr.external_colour"-->
            <!--                                                       v-model:target="door.attr.door_drip_colour"-->
            <!--                                                       :frame-profile="door.attr.profile"></wb-designer-question-door-drip-colour>-->

            <futureproducts-designer-question-head-drip-colour v-if="!is_firedoorrange" :fabricator="fabricator"
                                                               title="Choose A Head Drip colour"
                                                               :external-colour="door.attr.external_colour"
                                                               v-model:target="door.attr.head_drip_colour"
                                                               :frame-profile="door.attr.profile"
                                                               :opening-direction="door.attr.opening_direction"></futureproducts-designer-question-head-drip-colour>
          </div>

        </div>

        <div v-show="technical_should_show">
          <konic-doors-designer-question-measurements title="Enter Your Required Measurements"
                                                      :fabricator="fabricator"
                                                      :slab="door.attr.slab"
                                                      :door-range="door.attr.door_range"
                                                      :external-colour="door.attr.external_colour"
                                                      :internal-colour="door.attr.door_colour_internal"
                                                      :frame-profile="door.attr.profile"
                                                      :threshold="door.attr.threshold"
                                                      :frame-id="door.attr.frame_style.frame_id"
                                                      :side-panels="door.attr.side_panels"
                                                      :addons="door.attr.addons"
                                                      :cill="door.attr.cill"
                                                      :hardware-lock="door.attr.hardware_lock"
                                                      :hardware-hinge="door.attr.hardware_hinge"
                                                      :hardware-handle="door.attr.hardware_handle"
                                                      :hardware-knocker="door.attr.hardware_knocker"
                                                      :hardware-spy-hole="door.attr.hardware_spy_hole"
                                                      :hardware-escutcheon="door.attr.hardware_escutcheon"
                                                      :hardware-letterbox="door.attr.hardware_letterbox"
                                                      :hardware-letterbox-position="door.attr.hardware_letterbox_pos"
                                                      :overall-width="door.attr.measurements.overall_width"
                                                      :mdd="mdd"
                                                      :technical_should_show="technical_should_show"
                                                      v-model:target="door.attr.measurements"></konic-doors-designer-question-measurements>
        </div>

        <div v-if="is_firedoorrange">
          <futureproducts-designer-question-closer
              :fabricator="fabricator"
              v-model:target="door.attr.closer"
              :slab="door.attr.slab"
              :slab-width="door.attr.measurements.slab_width"
              :door-range="door.attr.door_range"
              :maintitle="'Choose Closer'"
              title=""
          ></futureproducts-designer-question-closer>
        </div>

        <div class="designeroption" v-if="reference_on" data-designer-component-id="reference">
          <h3>Enter A Door Reference</h3>
          <div class="stylesoption">
            <div class="form-group">
              <input dusk="door_reference" type="text" v-model="door.attr.reference" class="form-control">
            </div>
          </div>
        </div>
        <input v-else dusk="door_reference" type="hidden" v-model="door.attr.reference" class="form-control"
               value="Retail Door">

        <designer-question-notes v-model:target="door.attr.notes"></designer-question-notes>
      </template>

        <designer-navigation
                v-if="show_navigation"
                :visible_designer_configurator_components="visible_designer_configurator_components"
                transition="designer-navigation"
        ></designer-navigation>

    </div>

</template>

<script type="text/ecmascript-6">
    import DoorConfigurator from "../DoorConfigurator.vue";

    export default {
        mixins: [
            DoorConfigurator
        ],
        computed: {
            no_sbd() {
                return false;
            },
            is_firedoorrange() {
                return this.door_type === 'fire';
            },
            is_french() {
                return this.door_type === 'french';
            },
            is_stable() {
                return this.door_type === 'stable';
            },

            passed_filter_left() {
                return this.door.attr.frame_style.frame_id !== undefined && this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("left") !== -1;
            },
            passed_filter_right() {
                return this.door.attr.frame_style.frame_id !== undefined && this.door.attr.frame_material === 1 && this.door.attr.frame_style.checkedPanels.indexOf("right") !== -1;
            },
        },
        data() {
            return {

            }
        },
        methods: {
            defaults() {
                return {
                    119: {
                        "attr":{
                            "addons": {
                                "left": {},
                                "right": {},
                                "top": {},
                                "bottom": {},
                            },
                            "cill":149,
                            "drainage":1,
                            "door_range":119,
                            "door_colour_internal":764,
                            "external_colour":764,
                            "fabricator":29,
                            "frame_colour_external":764,
                            "frame_colour_internal":764,
                            "frame_material":2,
                            "frame_style":{
                                "frame_id":13,
                                "checkedPanels":[

                                ]
                            },
                            "glass_text":"",
                            "hardware_colour":22,
                            "hardware_handle":972,
                            "hardware_hinge":1100,
                            "hinge_side":1,
                            "laminated_glass":1,
                            "hardware_cylinder":450,
                            "hardware_decorative_handle":1112,
                            "hardware_letterbox":318,
                            "hardware_lock":395,
                            "hardware_knocker":315,
                            "hardware_security_chain":317,
                            "hardware_spy_hole":316,
                            "measurements":{
                                "overall_width":null,
                                "overall_height":null,
                                "left_width":null,
                                "right_width":null,
                                "top_box_drop":null
                            },
                            "notes":"",
                            "numerals":[
                                326,
                                326,
                                326,
                                326
                            ],
                            "opening_direction":1,
                            "profile":144606208,
                            "secured_by_design":1,
                            "side_panels":{
                                "left_composite_id":null,
                                "right_composite_id":null,
                                "left":8,
                                "right":8,
                                "left_panel_glass_id":1,
                                "right_panel_glass_id":1,
                                "top_panel_glass_id":1,
                                "left_composite_glass_id":1,
                                "right_composite_glass_id":1,
                                "right_flag_sill_id":149,
                                "left_flag_sill_id":149
                            },
                            "slab":1880,
                            "threshold":144606119,
                            "door_drip_colour":764
                        }
                    },
                    125: {
                      "attr": {
                          "addons": {
                              "left": {},
                              "right": {},
                              "top": {},
                              "bottom": {},
                          },
                        "cill": 149,
                        "drainage": 1,
                        "door_range": 125,
                        "door_colour_internal": 764,
                        "external_colour": 764,
                        "fabricator": 29,
                        "frame_colour_external": 764,
                        "frame_colour_internal": 764,
                        "frame_material": 2,
                        "frame_style": {"frame_id": 13, "checkedPanels": []},
                        "glass_text": "",
                        "hardware_colour": 22,
                        "hardware_handle": 972,
                        "hardware_hinge": 1100,
                        "hinge_side": 1,
                        "laminated_glass": 1,
                        "hardware_cylinder": 450,
                        "hardware_decorative_handle": 1112,
                        "hardware_letterbox": 318,
                        "hardware_lock": 395,
                        "hardware_knocker": 315,
                        "hardware_security_chain": 317,
                        "hardware_spy_hole": 316,
                        "measurements": {
                          "overall_width": null,
                          "overall_height": null,
                          "left_width": null,
                          "right_width": null,
                          "top_box_drop": null
                        },
                        "notes": "",
                        "numerals": [326, 326, 326, 326],
                        "opening_direction": 1,
                        "profile": 144606208,
                        "secured_by_design": 1,
                        "side_panels": {
                          "left_composite_id": null,
                          "right_composite_id": null,
                          "left": 8,
                          "right": 8,
                          "left_panel_glass_id": 1,
                          "right_panel_glass_id": 1,
                          "top_panel_glass_id": 1,
                          "left_composite_glass_id": 1,
                          "right_composite_glass_id": 1,
                          "right_flag_sill_id": 149,
                          "left_flag_sill_id": 149,
                          "lower_sidepanel_type": undefined
                        },
                        "slab": 1880,
                        "threshold": 144606119,
                        "door_drip_colour": 764,
                        "french_master": 1
                      }
                    }
                };
            },
        },
      watch: {
        'door.attr.frame_style.frame_id': {
          handler: window._.debounce(function () {
            const add_to_basket_btn = document.querySelectorAll('[data-id="add-to-basket-btn"]');
            if(this.door.attr.frame_style.frame_id === undefined) {
              add_to_basket_btn.forEach(function(element){
                element.setAttribute('disabled', 'disabled');
              });
            } else {
              add_to_basket_btn.forEach(function(element){
                element.removeAttribute('disabled');
              });
            }
          }, 50),
        },
      }
    }
</script>
